<!--
  <myupload
    ref='uploadFilelist'
    type='video'
    v-event.fileUpload='`return videoUpload_data.videoPath = ( await C.MyUpload() ).data||false`'
    :limit='1'
    api='upload'
    :params='{ file: "$file$", fileName: "$name$" }'
    loading='正在上传视频..||点击这里选择并上传视频...'
    x:filelist='{ name: "哈哈哈", url: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1589970005253&di=e29968fda6bd1d686f33d61485d50ecf&imgtype=0&src=http%3A%2F%2Fattach.bbs.miui.com%2Fforum%2F201408%2F05%2F222353wu5y5mzv6mprxvhn.jpg"  } '
    xstyle='margin-top: 10px;width:200px;height:200px;'
    style='margin-top: 10px;width:100%;height:90%;'>
  </myupload>
-->
<template>
  <!-- xbackground-color:rgba(0,0,0,0.4); -->
  <div style="display:inline-block;border-radius:5px;position:relative;" id="__myupload__"
    :class='{ isVideo: type === "video" }'
    @mouseenter='!boolean && (!readonly && readonly !== void 0) && innerfilelist && innerfilelist.length > 0 && (window.sleep.clear(50.11), actived = true)'
    @mouseleave='!boolean && (!readonly && readonly !== void 0) && innerfilelist && innerfilelist.length > 0 && window.sleep.clear(50.11, v => actived = false)'>
    <div class="w-h" v-loading='boolean'
      :element-loading-text='loading !== void 0 ? loading.split("|")[0] : "正在上传文件..."'
      :element-loading-background='loading !== void 0 && loading.split("|")[1] || "rgba(0,0,0,0.4)"'>
      <transition name='el-zoom-in-top'>
        <el-button class="el-icon-delete font12 blackFont" circle type=primary
          style='position: absolute;right: 10px;top: 9px;z-index:999;' title='从列表移除'
          v-if='!multiple && limit < 2 && !boolean && !readonly && readonly !== void 0 && readonly !== ""'
          v-show='actived' @click='removeFile()'></el-button>
      </transition>

      <el-upload style='display:inline-block;display:flex;width:100%;height:100%;'
        :list-type='listtype || "picture-card"' ref="upload" id='__upload__'
        :class='{ notEmpty: filelist && filelist.length > 0 || myfilelist.length > 0, isEmpty: filelist && filelist.length === 0, isVideo: type === "video", SingleInstance: limit === 1, readOnly: readonly === "" || readonly }'
        :action="api || '#'" :auto-upload="ifauto || false" :accept='accept || ""'
        :ZZ="$readonly = readonly === '' || readonly || false" :limit='limit || 0' :multiple='multiple || limit > 1'
        drag :show-file-list="showfilelist || true" :file-list='myfilelist'
        :on-preview='(file) => $listeners.preview ? $emit("preview", file, filelist, $this.$refs.upload, $this) : Data.src = file.url'
        :on-remove='(file, newfileList, tmp) => {
          filelist = myfilelist = newfileList;
          $emit("remove", file, newfileList, $this.$refs.upload, $this);
        }' :on-change='(file, newfileList, tmp) => {
          filelist = myfilelist = newfileList;
          $emit("change", file, newfileList, $this.$refs.upload, $this);
        }' :before-upload='(file) => beforeupload && beforeupload(file, filelist, $this.$refs.upload, $this)'
        remark:before-='返回false会阻止上传|移除'
        :before-remove='(file, filelist) => beforeremove && beforeremove(file, filelist, $this.$refs.upload, $this)'
        :http-request='MyUpload' x:on-success='' x:on-error='' cell-mouse-enter='mouseEnterHave'
        xcell-mouse-enter='mouseEnterNone' cell-mouse-leave=''>
        <i id='_upload_icon' xclass="el-icon-loading"
          :class="readonly === '' || readonly ? 'el-icon-question' : 'el-icon-circle-plus'"
          v-s.opacity="readonly === '' || readonly ? 0.4 : 0.8">
          <span v-if='tmp = loading !== void 0 && loading.split("|")[2]' style="font-size: 21px;margin-left: 10px;">{{
            tmp
            || "在这里上传视频..." }}</span>
        </i>

        <div slot="file" slot-scope="{file}">
          <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
          <span class="el-upload-list__item-actions" v-if="stopreview !== 'selfpreview'">
            <span v-if='!stopreview && selfpreview !== ""' class="el-upload-list__item-preview"
              @click=' $listeners.preview ? $emit("preview", file, filelist, $this.$refs.upload, $this) : Data.src = file.url'>
              <i class="el-icon-zoom-in"></i>
            </span>
            <!-- <span
              v-if="readonly !== '' && !readonly"
              class="el-upload-list__item-delete"
              @click="handleDownload(file)"
            >
              <i class="el-icon-download"></i>
            </span> -->
            <span v-if="readonly !== '' && !readonly" class="el-upload-list__item-delete"
              @click.stop='removeFile(file)'>
              <i class="el-icon-delete"></i>
            </span>

          </span>

        </div>

        <!-- <el-button size='medium' title='' icon='el-icon-folder-add' slot="trigger" type="primary" @click="" :loading="boolean">选择导入</el-button> -->
        <!-- <el-button size='medium' title='' icon='el-icon-upload' style="margin-left: 10px;" type="success" @click="submitUpload()" x:disabled='' :loading="!!number">开始上传</el-button> -->

      </el-upload>

    </div>

    <el-dialog width='95%' top='5vh' v-set:Data.src :visible='!!Data.src' @update:visible='Data.src = ""'
      append-to-body>
      <img width="100%" :src='Data.src || ""' />
    </el-dialog>

  </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import COS from 'cos-js-sdk-v5';
// 腾讯云上传
// 通过 import 引入的话，new TcVod(opts) 即可
// new TcVod.default(opts) 是 script 引入 的用法
const W = window, getOwn = A.getOwn;
const $Url = '/opportunity/tx-cloud-file/getPolicyTxCloudOpportunity';
const tcUpload = A.tcUpload = (mediaFile, onProgress) => {

  return new Promise((suc, err) => {
    const tcVod = new TcVod({
      getSignature: () => {
        return W.App.$post($Url, null, null).then(function (response) {
          return response.data.result === 'success' ? response.data.data : suc([false, 0]); //signature;
        }).catch(err => suc([false, 0]));
      },

      // 前文中所述的获取上传签名的函数

    });

    const uploader = tcVod.upload({
      mediaFile: mediaFile, // 媒体文件（视频或音频或图片），类型为 File
    });

    uploader.on('media_progress', typeof onProgress === 'function' ? onProgress : () => { });
    //uploader.on('media_progress', function(info) {
    //  console.log(info.percent) // 进度
    //});

    uploader.done().then(function (doneResult) {
      // deal with doneResult
      suc([true, doneResult]);
    }).catch(function (err) {
      // deal with error
      suc([false, err]);
    });

    // 回调结果说明
    // type doneResult = {
    //   fileId: string,
    //   video: {
    //     url: string
    //   },
    //   cover: {
    //     url: string
    //   }
    // }
    return uploader;
  });
};

// const res = await tcUpload(formData,(progress)=>{

// });
// if( !res || res[0] === false ) return false;

// 自定义文件 (*.m4v;*.mp4;*.avi;*.ogm;*.wmv;*.mpg;*.ogv;*.webm;*.mov;*.asx;*.mpeg;*.mp4;*.m4v;*.avi)
let $_Prototrigger, handler, Apis;
const Types = {
  'image': 'image/*',
  'audio': 'audio/*',
  'video': 'video/mp4,video/avi,video/m4v,video/mov,video/*,video/mkv',
  'mp3': 'audio/mpeg',
  'mp4': 'video/mp4',
  'pdf': 'application/pdf',
  'png': 'image/png',
  'txt': 'text/plain',
  'zip': 'application/zip',
};
export default {
  props: ['readonly', 'disabled', 'api', 'url', 'params', 'ifauto', 'type', 'multiple', 'limit', 'listtype', 'showfilelist', 'filelist', 'beforeupload', 'beforeremove', 'loading', 'stopreview', 'selfpreview'],
  data() {
    const type = this.type, filelist = this.filelist || [];
    return {
      loadings: '加载中...',
      accept: type && Types[type.toLowerCase()] || '',
      myfilelist: this.filelist = filelist.length > -1 ? filelist : [filelist],
      innerfilelist: [],
      value: '',
    };
  },

  watch: {
    filelist: {
      immediate: true,
      handler: handler = async function (filelist, older) {
        // console.warn(filelist, older);
        if (filelist == null || filelist.url === ' ') return;
        // if( (filelist[0]||'').url === ' ' ) return sleep( 500, () => this.myfilelist = [] ), null;
        // Array.isArray(filelist) && filelist.forEach(v=>v.url.trim() === '' && filelist.splice(filelist.indexOf(v), 1));

        if (this.stopreview === 'selfpreview' || this.$readonly) {
          const myfilelist = this.myfilelist;
          /*filelist = filelist.map( v => ( typeof v === 'string' ? {url: v} : v ) );
          console.warn(this.myfilelist = filelist);
          return await sleep(50000);*/
          filelist && filelist.length > -1
            ? this.myfilelist = filelist.map(v => (typeof v === 'string' ? { url: v } : v))
            : (myfilelist[0] || (myfilelist.push({}), myfilelist[0])).url = (
              filelist && filelist.length > -1
                ? typeof filelist[0] === 'string' ? filelist[0] : filelist[0].url
                : (filelist || {}).url
            ) || '#';
          // return;
        };

        // console.error(5555555555555, filelist, older, this.filelist );
        // console.error( filelist, this.myfilelist, this.stopreview, this);
        const ref = this.$vnode.data.ref;
        let tmp, uploadFileList = this.$refs.upload, uploadInner;
        if (!uploadFileList) {
          await sleep(50);
          uploadFileList = this.$refs.upload;
          if (!uploadFileList) return;
        };
        uploadInner = uploadFileList.$refs["upload-inner"];
        // console.error(uploadInner,filelist, filelist, filelist.length, ( this.limit || 999999 ) );
        if (!uploadInner) return;
        // console.warn(filelist, uploadFileList.uploadFiles.length, this.innerfilelist);
        if (!filelist) {
          this.removeFile();
          // this.innerfilelist = [], this.myfilelist = [];
          // uploadFileList.uploadFiles.splice(0);
          return;
        };
        const old = filelist;
        filelist = uploadFileList.uploadFiles;

        if (filelist.length === 0) {
          this.myfilelist = filelist = typeof old === 'object' ? old.length > -1 ? old : [old] : [{ name: 'xxx', url: old }];
          // console.error(this.myfilelist,old);
        };
        // filelist.length === void 0 && ( filelist = [filelist] );
        // this.value = filelist;
        // this.$emit('update:value',filelist);
        ref && (this.$host[ref] = filelist);
        // console.error(filelist, $$('.el-upload-list__item-thumbnail', this.$el) );
        if (this.innerfilelist[0] === filelist[0] && this.innerfilelist.length === filelist.length) return;
        // console.warn( this.innerfilelist[0], filelist[0], this.innerfilelist.length, filelist.length );

        (tmp = this.__uploadel__ = uploadInner.$el).style;
        // console.error( filelist.length > 0, this.type );
        if (filelist.length > 0 && this.type === 'video') {
          // console.error($$('li.el-upload-list__item>div', this.$el), this.$el);
          // console.error(filelist);
          await sleep(50);
          $$('li.el-upload-list__item>div', this.$el).forEach((img, i) => {
            // console.warn(img,i);
            img = img.firstElementChild;
            if (img.nodeName !== "IMG") return;
            const parent = img.parentNode;
            img.outerHTML = `<video ${this.$readonly ? 'autoplay' : ''} controls width="100%" height="100%" src="${img.src}" style="${this.$attrs.videoStyle || ''}" />`;
            // console.warn(img,this.$readonly);
            if (this.$readonly) return;
            (img = parent.querySelector('video')).ondurationchange = () => {
              file.duration = (img.__view__ || {}).videoSeconds = img.duration;
              img.ondurationchange = null;
            };
            // console.error(img,parent,filelist,i);
            const file = img.__file__ = filelist[i];
            img.__this__ = this, img.__index__ = i;
            file.video = img;
            // console.error([ img ]);
            img.onmouseenter = $$.__delete_enter__ || ($$.__delete_enter__ = function () {
              // console.error(11111111);
              this.__delete__
                ? true
                : $$.__delete__
                  ? this.parentNode.insertAdjacentElement('afterBegin', $$.__delete__.cloneNode())
                  : this.parentNode.insertAdjacentHTML('afterBegin', `<i class="el-icon-delete ZOOM" style="
                  position: absolute;
                  right: 15px;
                  top: 15px;
                  font-size: 25px;
                  color: white;
                  background: darkred;
                  padding: 15px;
                  border-radius: 50%;
                  cursor: pointer;
                  z-index: 77;
                  transform: scale(0);
                  transition: all 250ms ease-in-out;
              " title="移除该视频" ></i>`);
              const first = this.parentNode.firstElementChild;
              this.__delete__ = first.__delete__ = first.style;
              !$$.__delete__ && ($$.__delete__ = first);
              first.onmouseleave = $$.__delete_leave__;
              first.onclick = () => this.__this__.removeFile(this.__file__);
              // console.warn(this);
              sleep.clear(20.134569712 + (first.__index__ = this.__index__), v => {
                first.style.transform = 'scale(1)';
                // (this.__file__.__view__||{}).onhover = true;
              });
              const f = this.__file__.__view__;
              if (f) f.onhover = true, f.$el._view('t:background-color:opacity');
              // console.warn(777777777);
            });
            img.onmouseleave = $$.__delete_leave__ || ($$.__delete_leave__ = function () {
              sleep.clear(20.134569712 + this.__index__, v => {
                this.__delete__.transform = 'scale(0)';
                // console.error(this);
                // (this.__file__.__view__||{}).onhover = false;
              });
              const view = (this.__file__ || 0).__view__;
              view && this.__this__.$host.__view__ !== view && (
                view.onhover = false,
                view.$el._view('t:background-color:opacity')
              );
            });
            // console.error(parent.querySelector('video'));
          });
          this.actived = true;
        } else this.actived = false;
        console.log(filelist);
        this.innerfilelist = filelist.slice(0);
        console.log(this.innerfilelist);
        // console.error( filelist.length, this.limit, tmp );
        if (filelist.length >= (this.limit || 999999)) {
          tmp.previousElementSibling.style.maxWidth = '100%';
          tmp = tmp.style;
          tmp.opacity = 0;
          await sleep(40);
          tmp.display = "none";
        } else {
          tmp.previousElementSibling.style.maxWidth = '';
          tmp = tmp.style;
          tmp.opacity == '0' && (await sleep(50), tmp.opacity = 1);
          tmp.display = '';
        };

      }
    },

    boolean: async function (bool) {
      let Span = this._ProgressSpan;
      if (!bool) {
        await this.$nextTick();
        return Span && (Span.style.animation = '');
      };
      if (!this.$el.contains(Span)) {
        await this.$nextTick();
        Span = $('.el-loading-spinner', this.$el);
        // if( Span.$('#XXXYYY') ) return;
        Span = this._ProgressSpan = Span.$prepend(`<span id="XXXYYY" style="
            text-shadow: 0px 0px 0px;
            color: rgb(236, 223, 223)!important;
            font-size: 24px;
            position: absolute;
            top: 50%;
            margin-top: -28px;
            font-family: monospace;
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: center;
        "><span style="animation: fadecolor 1.5s ease-out infinite;">10%</span></span>`).firstElementChild;
      };
      Span.style.animation = "fadecolor 1.5s ease-out infinite";
      Span.textContent = '0%';
      // console.error(Span);

    },

  },

  methods: {

    _MyUpload: async function () {
      // this.$emit( "upload",this.filelist, this.$refs.upload, this );
      console.log(this.innerfilelist);
      let innerfilelist = this.innerfilelist;
      console.warn(this.type, this.errors)
      if (innerfilelist.length < 1) {
        alertError("请在中间+加号处点击并选择上传你的视频！", 4000, '选择上传视频');
        return false;
      };
      this.boolean = true; // return await sleep(0), this.loading = '正在上传第一个视频..|', console.error(this), await sleep(60000);

      let multiple = this.api === '/tcUpload', $file$;
      /*
      if ( Api !== '/tcUpload' ) {
        api = ( $_Prototrigger || ( $_Prototrigger = W.$_Prototrigger ) )[ this.api || 'fileUpload'  ]; //this.Apis.fileUpload[0]
        if( !api ) return sleep(100).then(v=>this.boolean=false), alertError("上传文件的api地址为空! 请检查..."), false;
      };*/

      innerfilelist = innerfilelist.filter(v => (v.file = v.raw) + '' === '[object File]');
      if (innerfilelist.length < 1) {
        alertWarn("当前文件列表里的视频都已经上传过了, 无须重复上传！", 2500, 'bottom-right');
        return false;
      };

      // return console.warn( innerfilelist );
      let res = false, tips = ''; // = innerfilelist[0];
      let index = 0, iserr = false, err, tip, loading = this.loading;

      for ($file$ of innerfilelist) {
        const myfile = $file$.file;

        if (myfile.videoUpload === true) { ++index; continue; };

        tip = innerfilelist.length > 1 ? this.$host.loading = '正在上传第' + (++index) + '个视频..|' : '正在上传视频..|';

        if (myfile.txUpload !== true) {
          this._ProgressSpan && (this._ProgressSpan.textContent = '0.0%');
        };

        /*await sleep(2500);
        // console.error($file$, index);
        err = '(上传腾讯云失败)';
        alertError.vue && alertError.vue.close(console.error(7777777777));
        alertError( tips += tip.slice(2,-3) + '失败！' + err + '<br>', 0, '部分视频上传失败！' );
        continue;*/

        let view = $file$.__view__ || {}, $view = false;
        if (multiple) {
          const coverPath = view.coverPath;
          // console.log(coverPath,view.$coverFile);
          if (coverPath && !coverPath.startsWith('http')) {
            if (view.$coverFile.coverPath !== void 0) {
              const form = new FormData(); form.append('file', view.$coverFile); // || $.toFile(coverPath,'upload.png'
              console.warn(view.$coverFile, view);
              console.log('我在上传');
              res = await this.$post('/auth-file/uploadLinux', form, false); // /file/uploadLinux
              /*res = await tcUpload( view.$coverFile , (progress)=>{
                console.error('当前上传进度: ',progress);
                this._ProgressSpan && ( this._ProgressSpan.textContent = ( progress.percent * 100 ).toFixed(1) + '%' );
              } );
              !res || res[0] === false
              ? res = false
              : ( res = res[1] ).isuccess = true;*/

              if (res.isuccess) {
                await sleep(50);
                view.coverPath = res.data.data || res.data; // res.video.url;
                // res.isuccess = !await $.isblack( view.coverPath = window.ONFILE + res.data.data );
              };
              if (!res.isuccess) {
                alertError(tips = `上传第${index}个视频的封面失败("${$file$.name}")！<br>请重新上传！`, 0, '视频封面上传失败！');
                break;
              };
              myfile.uploadLinux = true;
            } else {
              console.warn('采用默认封面...');
              ($view = With({}, view)).coverPath = '';
            };
          };
        };

        if (myfile.txUpload !== true) {
          console.log("2222")

          res = await tcUpload(myfile, (progress) => {
            console.error('当前上传进度: ', progress);
            this._ProgressSpan && (this._ProgressSpan.textContent = (progress.percent * 100).toFixed(1) + '%');
          });
          // res = await this.$post('auth-file/uploadLinux',this.myfilelist[0],false);
          console.log(res)
          !res || res[0] === false
            ? res = false
            : ((res = res[1]).isuccess = true, res = res.data = {
              path: res.video.url,
              file: res.video.url,
              cover: (res.cover || 0).url || '',
              videoId: res.fileId,
            });
          console.warn('最终响应:: ', res);

        } else res = true;

        if (res) {
          if (res !== true) {
            myfile.txUpload = true;
            $file$.file = $file$.url = view.videoPath = ($view || {}).videoPath = res.path;
            res.cover && (view.coverPath = ($view || {}).coverPath = res.cover);
          };
          /*const view = $file$.__view__ || {};
          res.cover && ( view.coverPath =  res.cover );
          $file$.file = $file$.url = view.videoPath = res.path;
          if( multiple ) {
            const coverPath = view.coverPath;
            console.log(coverPath);
            if( !coverPath.startsWith('http') ) {
              const form = new FormData();
              console.warn(view.$coverFile,view);
              form.append('file', view.$coverFile || $.toFile(coverPath,'upload.png') );
              res = await this.$post('/file/uploadLinux',form,false);
              res.isuccess && ( view.coverPath = window.ONFILE + res.data.data );
            };
          };*/
          if (multiple) {
            res !== true && (view.videoId = ($view || {}).videoId = res.videoId);
            res = await this.$post('videoUpload', $view || view, false);
            if (res.isuccess) { myfile.videoUpload = true; continue; };
            err = '(上传到衍书失败)';
          };
        } else {
          err = '(上传腾讯云失败)';
        };

        if (multiple) {
          iserr && iserr.close();
          tips += tip.slice(2, -3) + '失败！' + err + '<br>';
          !iserr
            ? iserr = alertError(tips, 0, '部分视频上传失败！')
            : sleep.clear(46.1533974122, v => iserr = alertError(tips, 0, '部分视频上传失败！'));
        };
      };

      sleep(20).then(v => {
        this.boolean = false;
        this.$host.loading = loading;
      });
      // console.warn(111111,res, this.params);
      console.warn('最终的tips是否为空', tips === '');
      return multiple ? tips === '' // 批量上传视频
        : res;
    },
    MoveTheCloud2(file) {
      return new Promise(async (resolve, reject) => {
        console.log(file);
        const fileType = file.type.split('/')
        const fileName = (file.uid + file.lastModified) + '.' + fileType[1]
        const form = new FormData();
        form.append('fileName', fileName);
        form.append('contentType', file.type);
        const res = await this.$post('/opportunity/tools/getYiDongCloudSignaturePolicy', form, false);
        const obj = res.data.data;
        console.log(obj);
        obj.body = file;
        // const s = qs.stringify(obj)
        axios({
          method: 'POST',
          url: 'https://yuechuang.eos-wuxi-1.cmecloud.cn',
          data: obj,
          // withCredentials: true,
          timeout: 120000,

        }).then(function (res) {
          console.log('新增的', res);
          return resolve(res)

        })


        // var s3 = new AWS.S3({
        //   apiVersion: '2006-03-01',
        //   accessKeyId: "1U04U6B1SL3IJNAOIAMN",
        //   secretAccessKey: "qUj578mhXovjWGXQi3BiooJ9YQd5Ded0sfvQGWx4",
        //   endpoint: "http://eos-shanghai-2.cmecloud.cn",
        //   signatureVersion: 'v2',
        //   sslEnabled: false
        // });
        // var s3 = new AWS.S3(res.data.data)
        // if (file) {

        //   console.log(fileType);
        //   var params = {
        //     Key: fileName,
        //     Bucket: res.data.data.bucket,
        //     ContentType: file.type,
        //     ACL: res.data.data.acl,
        //     Body: file
        //   }
        //   s3.putObject(params, function (err, data) {
        //     const fileUrl = 'http://yuechuang.eos-shanghai-2.cmecloud.cn/' + fileName
        //     const fileobj = {
        //       fileName: file.name,
        //       fileurl: fileUrl
        //     }
        //     console.log(err);

        //     // results.innerHTML = err ? 'ERROR!' : 'UPLOADED.';
        //     //http://aojv.eos-shanghai-2.cmecloud.cn/interview/chenjingtest1001.aac      
        //   });
        // } else {
        //   alert('重新上传');
        // }
      })

    },

    getTenXunCloudKey() {
      return new Promise((resolve, reject) => {
        W.App.$post($Url, null, null).then(function (res) {
          if (res.data.data) {
            resolve(res.data.data)
          }
        })
      })
    },
    // 秘钥初始化
    getCosInIt() {
      const cos = new COS({
        SimpleUploadMethod: 'putObject', // 强烈建议，高级上传、批量上传内部对小文件做简单上传时使用putObject,sdk版本至少需要v1.3.0
        getAuthorization: async (options, callback) => {
          // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
          // 异步获取临时密钥
          // 服务端 JS 示例：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
          // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
          // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
          const data = await this.getTenXunCloudKey();
          callback({
            TmpSecretId: data.tmpSecretId,
            TmpSecretKey: data.tmpSecretKey,
            // v1.2.0之前版本的 SDK 使用 XCosSecurityToken 而不是 SecurityToken
            SecurityToken: data.sessionToken,
            // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
            StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
            ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000900
          });
        }
      });
      return cos
    },
    // 腾讯云对象存储上传
    async TenXunCloudUploadFile(file) {
      var that = this
      return new Promise(async (resolve, reject) => {
        const key = await this.getTenXunCloudKey()
        const cos = this.getCosInIt()
        const fileName = file.uid + file.lastModified
        const fileType = file.name.split('.')

        cos.uploadFile({
          Bucket: key.bucket, // 填写自己的 bucket，必须字段
          Region: key.region, // 存储桶所在地域，必须字段
          Key: key.filePath + '/' + fileName + '.' + fileType[fileType.length - 1], // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
          Body: file,
          /* v1.4.3之前的版本必须，v1.4.3及以后的版本非必须 */
          SliceSize: 1024 * 1024 * 5, // 触发分块上传的阈值，超过5MB 使用分块上传，小于5MB使用简单上传。可自行设置
          onProgress: function (progressData) {
            console.log('上传进度：', progressData);
            const loadingtext = '上传中...' + progressData.percent * 100 + '%';
            if (that.loadings) {
              that.loadings.setText(loadingtext);
            } else {
              // 首次创建loading实例
              that.loadings = that.$loading({
                lock: true,
                text: loadingtext,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
              });
            }
            // that.loadings.close()
            console.log(that.loadingtext);

          },
        }).then(data => {
          console.log('上传成功', data);
          const url = key.baseHttp + key.filePath + '/' + fileName + '.' + fileType[fileType.length - 1]
          resolve(url)
        }).catch(err => {
          console.log('上传出错', err);
        });
      })
    },
    openLoading() {
      //loading请求等待
      var that = this
      that.loadings = that.$loading({
        lock: true,
        text: that.loadingtext,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    async MyUpload() {
      console.log('上传了一个视频', this.innerfilelist);
      let innerfilelist = this.innerfilelist;

      const type = this.type === 'image' ? '图片' : '视频';

      if (innerfilelist.length < 1) {
        console.log(this.$parent.$vnode.context);
        const required = this.$parent.$vnode.context.Myruleobj ? (this.$parent.$vnode.context.Myruleobj[this.$parent.labelFor] || '').length : false;
        if (!required) return { file: ' ' }; // 如果不是必须上传, 跳过

        alertError(`请在中间+加号处点击并选择上传你的${type}！`, 4000, `选择上传${type}`);
        return false;
      };

      innerfilelist = innerfilelist.filter(v => (v.file = v.raw) + '' === '[object File]');
      if (innerfilelist.length < 1) {
        console.log(innerfilelist);
        alertWarn(`当前文件列表里的${type}都已经上传过了, 无须重复上传！`, 2500, 'bottom-right');
        return { file: '' };
      };

      this.boolean = true;

      const form = new FormData();
      form.append('file', innerfilelist[0].file);
      console.log(innerfilelist[0].file);
      console.log('我在上传2');
      // const res = await this.$post('/opportunity/auth-file/uploadLinux', form, false);
      const res = await this.TenXunCloudUploadFile(innerfilelist[0].file);
      // const res = await this.MoveTheCloud(innerfilelist[0].file);
      console.log(res);
      sleep(100).then(v => {
        this.boolean = false;
        // this.$host.loading = loading;
      });

      // if( res.fileurl ) {
      //     return { file: res.fileurl };
      // } else {
      if (res) {
        return { file: res };
      } else {
        alertError(`上传${type}失败("${$file$.name}")！<br>请重新上传！`, 0, `${type}上传失败！`);
        return false;
      };

    },
    MoveTheCloud(file) {
      return new Promise((resolve, reject) => {
        var s3 = new AWS.S3({
          apiVersion: '2006-03-01',
          accessKeyId: "1U04U6B1SL3IJNAOIAMN",
          secretAccessKey: "qUj578mhXovjWGXQi3BiooJ9YQd5Ded0sfvQGWx4",
          endpoint: "https://eos-wuxi-1.cmecloud.cn",
          signatureVersion: 'v2',
          sslEnabled: false
        });
        if (file) {
          //console.log(file);
          const fileName = file.uid + file.lastModified
          const fileType = file.type.split('/')
          //console.log(fileType);
          var params = {
            Key: "study/" + fileName + '.' + fileType[1],
            Bucket: "yuechuang",
            ContentType: file.type,
            ACL: "public-read",
            Body: file
          }
          s3.putObject(params, function (err, data) {
            //console.log(err,data);
            if (err) return alert('重新错误,请重新上传');
            const fileUrl = 'https://yuechuang.eos-wuxi-1.cmecloud.cn/study/' + fileName + '.' + fileType[1]
            const fileobj = {
              fileName: file.name,
              fileurl: fileUrl
            }
            console.log(fileUrl);
            return resolve(fileUrl)
            // results.innerHTML = err ? 'ERROR!' : 'UPLOADED.';
            //http://aojv.eos-shanghai-2.cmecloud.cn/interview/chenjingtest1001.aac      
          });
        } else {
          alert('重新上传');
        }
      })

    },
    removeFile(file) {
      var tmp, tmpList = this.$refs.upload.uploadFiles;
      file = typeof file === 'object' && file !== null
        ? (tmp = tmpList.indexOf(file), file)
        : tmpList[tmp = file || 0];
      tmpList.splice(tmp === -1 ? 99999 : tmp, 1);
      this.filelist = this.myfilelist = this.$clone(tmpList);
      this.$emit("remove", file, tmp, tmpList, this.$refs.upload, this);
      if (this.limit > 1 && tmpList.length === this.limit - 1) {
        (async () => {
          (tmp = this.__uploadel__).previousElementSibling.style.maxWidth = '';
          tmp = tmp.style;
          tmp.opacity == '0' && (await sleep(50), tmp.opacity = 1);
          tmp.display = '';
          // await this.$nextTick();
          // this.handler(  );
        })();
      };
    },

  },

  created() {
    // console.log(window.b = this);

  },

  mounted() {
    // console.error($('',this.$el));
    // <span style="font-size: 21px;margin-left: 10px;">在这里上传视频...</span>
    if (this.limit > 1) {
      // console.error(this.limit,this.$el);
      this.$el.querySelector('.el-upload__input').onchange = event => {
        // console.error(event.target.files[0].uid);
        if (!(event = event.target.files)[0].uid && this.myfilelist.length + event.length > this.limit) {
          return alertWarn('最多批量选择15个视频,请重新选择！', '选择视频数量超出限制');
        };
        // console.error(event.target.files, this.filelist, this.myfilelist);
      };
    };
  },

};

</script>

<style xscoped>
/*#__upload__ .el-upload--picture-card {
    border: 0px!important;
  }*/
#__upload__ .el-upload-dragger {
  width: 100% !important;
  height: auto;
  /* =!important; */
  border: 0px !important;
  /*display: inline-block;*/
  display: flex;
  align-items: center;
  justify-content: center;
  /*position: relative;*/
  margin-top: -1px;
  background: transparent;
  transition: all 100ms ease-out 0s;
  opacity: 1;
}

#__upload__ .el-upload--picture-card {
  transition: all 100ms ease-out 0s;
  opacity: 1;
  border: 1px dotted var(--Colorlight);
  background-color: transparent;
  width: 100%;
  height: 100%;
  min-width: 148px;
  min-height: 148px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  /*margin-left: 10px;*/
}

#__upload__.notEmpty .el-upload--picture-card {
  box-shadow: -3px 3px 15px 3px #cccccc;
}

#__upload__ .el-upload--picture-card:hover,
.el-upload:focus {
  border: 2px dashed var(--Colorlight) !important;
  /*color: var(--Colorlight)!important;*/
  text-shadow: 0px 0px 0px !important;
}

#__upload__ .el-upload--picture-card:hover #_upload_icon,
.el-upload:focus #_upload_icon {
  text-shadow: 0px 0px 0px !important;
}

#__upload__ #_upload_icon {
  opacity: 0.8;
  font-size: 45px;
  color: var(--Colorlight) !important;
  position: relative;
  display: inline-flex;
  align-items: center;
  /*color: var(--Themecolor)!important;*/
}

#__upload__.notEmpty .el-upload-list--picture-card {
  width: 100%;
}

#__upload__.isVideo.notEmpty .el-upload-list--picture-card {
  flex-shrink: 0;
  flex-flow: column;
  /*flex-flow: row;*/
  /*width: 100%;*/
  max-width: 80%;
}

#__upload__.readOnly .el-upload-list--picture-card {
  max-width: 100% !important;
}

#__upload__.isVideo .el-upload-list__item-actions {
  display: none;
}

#__upload__.isVideo .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: auto !important;
}

#__upload__.SingleInstance .el-upload-list--picture-card>li {
  margin-right: 0px;
}

#__upload__.isEmpty .el-upload-list--picture-card>li {
  transition: all .3s cubic-bezier(.55, 0, .1, 1);
}

#__upload__ .el-upload-list--picture-card {
  display: flex;
  overflow: auto;
  flex-wrap: wrap;
}

#__upload__.notEmpty .el-upload-list--picture-card {
  width: 100%;
  height: 100%;
  max-height: 100vh;
}

#__upload__.notEmpty .el-upload-list--picture-card img {
  object-fit: cover;
  /*object-fit: contain;*/
  max-height: 100vh;
}

#__upload__ .el-upload-list--picture-card>li>div {
  /*width: 100%;*/
  height: 100%;
}

#__upload__.isVideo .el-upload-list--picture-card>li>div {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  background: radial-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6));
}

#__upload__.isVideo .el-upload-list--picture-card>li>div>video {
  width: 100%;
  height: 100%;
}

#__upload__ .el-upload-list--picture-card>li {
  margin: 0px;
  margin-right: 10px;
  width: 100%;
  height: 100%;
  min-width: 148px;
  min-height: 148px;
}

#__upload__.isVideo .el-upload-list--picture-card>li {
  min-height: 280px;
  /*min-height: 220px;*/
  margin-top: 10px;
}

#__upload__.isVideo .el-upload-list--picture-card>li:first-child {
  margin-top: 0px;
}

/* #__upload__ .el-upload-list--picture-card > li:last-child {
    margin-right: 10px;
  }
  #__upload__ .el-upload-list--picture-card > li:first-child {
    margin-right: 0px;
  }*/

#__upload__ .el-upload-list--picture-card.is-disabled+.el-upload--picture-card {
  border: 1px dotted #ccc;
}

#__upload__.notEmpty .el-upload-list--picture-card.is-disabled+.el-upload--picture-card {
  display: none !important;
}

#__upload__.notEmpty .el-upload-list--picture-card.is-disabled>li {
  border: none !important;
}

#__upload__ .el-upload-list--picture-card.is-disabled+.el-upload--picture-card:hover,
#__upload__ .el-upload-list--picture-card.is-disabled+.el-upload:focus {
  border: 2px dashed #ccc !important;
}

#__upload__ .el-upload-list--picture-card.is-disabled+.el-upload .el-upload-dragger {
  cursor: not-allowed !important;
}

#__myupload__ .el-loading-spinner .path {
  /*stroke: var(--Themecolor) !important;*/
  stroke: rgb(236, 223, 223) !important;
}

#__myupload__ .el-loading-spinner .el-loading-text {
  color: rgb(236, 223, 223) !important;
  font-size: 15px;
}

#__myupload__ .el-loading-spinner {
  top: 50%;
  margin-top: -63px;
  width: 100%;
  text-align: center;
  position: absolute;
}

#__myupload__ .el-loading-spinner .circular {
  height: 90px;
  width: 90px;
}

@keyframes fadecolor {
  50% {
    color: rgba(236, 223, 223, 0.8);
    opacity: 0.7;
  }
}

.el-form-item__content #__myupload__ {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/$MyUpload.vue